import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);


  if (req.url.includes('/api/login') && !req.url.includes('/api/login/reset')) {
    return next(req);
  }

  const storedUserDetails = sessionStorage.getItem('user');
  const authToken = storedUserDetails ? JSON.parse(storedUserDetails)?.token : null;

  const authReq = authToken
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${authToken}` },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        sessionStorage.removeItem('userDetails'); // Clear invalid token
        router.navigate(['/authentication/login']); // Redirect to login page
      }      
      return throwError(() => error);
    })
  );
};
